module.exports = __webpack_public_path__ + "assets/img/box3_img2.41177882.png";